import { createContext, useMemo, useState } from 'react';

import { Signer } from ':fat/core/signer';

export const SignerContext = createContext<{
  signer: Signer | null;
  setSigner: (signer: Signer) => void;
}>({ signer: null, setSigner: () => {} });

type SecurityFrameSignerProviderProps = {
  children: React.ReactNode;
};

export function SecurityFrameSignerProvider({ children }: SecurityFrameSignerProviderProps) {
  const [signer, setSigner] = useState<Signer | null>(null);

  const value = useMemo(() => ({ signer, setSigner }), [signer, setSigner]);

  return <SignerContext.Provider value={value}>{children}</SignerContext.Provider>;
}
